/* StorazeBiz live copy (Dev, Grok): back-to-top reveal, NAS bay pills, mobile summary bar. Remove with its include in layout/theme.liquid to undo. */
(function(){
  // 1. back-to-top only after scrolling
  var top=document.querySelector('.sbf-top');
  if(top){var t=function(){top.classList.toggle('is-visible',window.scrollY>window.innerHeight*1.2)};window.addEventListener('scroll',t,{passive:true});t();}

  // 18. NAS bay pills
  document.querySelectorAll('[data-sz-bays]').forEach(function(bar){
    var root=bar.closest('storaze-showroom')||document;
    var cards=[].slice.call(root.querySelectorAll('.sz-card[data-title]'));
    var bays=function(c){var m=(c.getAttribute('data-title')||'').match(/(\d+)\s*-?\s*bay/i);return m?parseInt(m[1],10):0};
    var counts={};cards.forEach(function(c){var b=bays(c);c.setAttribute('data-bays',b)});
    var groups={'1-2':function(b){return b>0&&b<=2},'4':function(b){return b===4},'5+':function(b){return b>=5}};
    bar.querySelectorAll('button[data-bay]').forEach(function(btn){
      var k=btn.getAttribute('data-bay');
      if(k!=='all'){var n=cards.filter(function(c){return groups[k](+c.getAttribute('data-bays'))}).length;if(!n){btn.hidden=true}else{btn.textContent+=' ('+n+')'}}
      btn.addEventListener('click',function(){
        bar.querySelectorAll('button[data-bay]').forEach(function(b){b.setAttribute('aria-pressed',b===btn?'true':'false')});
        cards.forEach(function(c){var b=+c.getAttribute('data-bays');if(k==='all'||groups[k](b)){c.removeAttribute('data-bay-hidden')}else{c.setAttribute('data-bay-hidden','')}});
      });
    });
    if(!cards.some(function(c){return +c.getAttribute('data-bays')>0}))bar.hidden=true;
  });

  // 20. mobile summary bar
  var bar=document.querySelector('[data-sb-mbar]');
  if(bar){
    // Dawn can re-render the buy area, so look it up on every check instead of observing one node.
    var findBuy=function(){return document.querySelector('.product-form__buttons')||document.querySelector('product-info')};
    var ticking=false;
    var check=function(){ticking=false;var buy=findBuy();if(!buy)return;var r=buy.getBoundingClientRect();var past=r.bottom<0;bar.classList.toggle('is-visible',past);bar.setAttribute('aria-hidden',past?'false':'true')};
    window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(check)}},{passive:true});
    check();
    var cartBtn=bar.querySelector('[data-sb-mbar-cart]');
    if(cartBtn)cartBtn.addEventListener('click',function(){var s=document.querySelector('.product-form__submit');var buy=findBuy();if(s&&!s.disabled){s.click()}else if(buy){buy.scrollIntoView({behavior:'smooth',block:'center'})}});
  }
})();
